import { store } from '@/store/store';
import { StudyStoreState } from '../enums/study-store-state';

export class StudyStoreRegister {
	public registerStudyStore(studyId: number): void {
		if (this.storeExist(studyId)) {
			return;
		}
		const storeInitState = this.storeInitState();

		store.actions.registerStudyStore(studyId, storeInitState);
	}

	private storeExist(studyId: number): boolean {
		return !!store.getters.getStudyStore(studyId);
	}

	private storeInitState(): StudyStoreState {
		if (store.getters.userLoggedIn()) {
			return StudyStoreState.CREATED;
		}

		return StudyStoreState.READY;
	}
}
